import axios from 'axios';
import { msalConfig } from '../authConfig';
import { IPublicClientApplication, AccountInfo } from '@azure/msal-browser';
import { getAccessToken } from './TokenService';

const backendBaseUrl = msalConfig.baseUrl;

export async function getDataSources(msalInstance: IPublicClientApplication, account?: AccountInfo) {
    const token = await getAccessToken(msalInstance, account);
    const response = await axios.get(`${backendBaseUrl}api/DataSource`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
}


export async function getPermittedDataSources(msalInstance: IPublicClientApplication, account?: AccountInfo) {
    const token = await getAccessToken(msalInstance, account);
    const response = await axios.get(`${backendBaseUrl}api/DataSource/permitted`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
}

export async function createDataSource(msalInstance: IPublicClientApplication, data: any, account?: AccountInfo) {
    const token = await getAccessToken(msalInstance, account);
    const response = await axios.post(`${backendBaseUrl}api/datasource`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
}

export async function updateDataSource(msalInstance: IPublicClientApplication, id: string | number, data: any, account?: AccountInfo) {
    const token = await getAccessToken(msalInstance, account);
    const response = await axios.put(`${backendBaseUrl}api/DataSource/${id}`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
}
